<template>
  <TopNav v-if="!hideTopNav" />
  <div
    v-if="bannerVisible && !hideTopNav"
    class="border-b border-amber-400/20 bg-amber-500/10 px-4 py-2 flex items-center justify-between"
  >
    <span class="text-sm text-amber-200">{{ bannerText }}</span>
    <button
      v-if="actionVisible"
      type="button"
      class="rounded-lg px-3 py-1 text-sm font-medium text-amber-100 ring-1 ring-amber-400/30 bg-amber-500/20 hover:bg-amber-500/35 transition"
      @click="action"
    >
      {{ actionLabel }}
    </button>
  </div>
  <router-view />
  <CookieConsentBanner />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import TopNav from './components/TopNav.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';
import { useOrdersStore } from './store/orders';
import { useAppUpdate } from './composables/useAppUpdate';
import { applyRegionalLanguageDefault } from './composables/useLanguage';

const route = useRoute();
const ordersStore = useOrdersStore();
const { bannerVisible, bannerText, actionLabel, actionVisible, action } = useAppUpdate();
const hideTopNav = computed(() => Boolean(route.meta.hideTopNav));
onMounted(() => {
  ordersStore.connectRealtime();
  void ordersStore.loadOrders();
  // ru/uk are default only in Ukraine; elsewhere fall back to English (manual choice wins).
  void applyRegionalLanguageDefault();
});
</script>
